import { useState } from "react";
import { cartItemsVar } from "../Utils/cache";
import { useLazyQuery, useReactiveVar } from "@apollo/client";
import { GET_CART } from "../Utils/Queries";

const useGetCart = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);

  const cartItems = useReactiveVar(cartItemsVar);

  const [getCart, { data, refetch }] = useLazyQuery(GET_CART);

  const handleGetCart = async () => {
    setIsLoading(true);

    await getCart({
      pollInterval: 200000,
    })
      .then((res) => {
        setIsLoading(false);
        setSuccess(true);
        
        const serverCartItems = res?.data?.getMyShoppingCart?.items || [];
        const tempCartItems = JSON.parse(localStorage.getItem('tempCartItems') || '[]');
        
        // If we have temporary cart items and server cart is smaller, merge them
        if (tempCartItems.length > serverCartItems.length) {
          // Find items in temp cart that aren't in server cart yet
          const newItems = tempCartItems.filter(tempItem => 
            !serverCartItems.some(serverItem => 
              serverItem.product._id === tempItem.product._id
            )
          );
          
          // Merge server items with new items
          const mergedCart = [...serverCartItems, ...newItems];
          cartItemsVar(mergedCart);
          
          // Clean up temp storage after successful merge
          if (newItems.length === 0) {
            localStorage.removeItem('tempCartItems');
          }
        } else {
          cartItemsVar(serverCartItems);
          // Clean up temp storage if server is up to date
          localStorage.removeItem('tempCartItems');
        }
      })
      .catch((err) => {
        console.error("Error Newe Cart", err);
        setIsLoading(false);
        
        // If server request fails, try to use temp cart as fallback
        const tempCartItems = JSON.parse(localStorage.getItem('tempCartItems') || '[]');
        if (tempCartItems.length > 0) {
          cartItemsVar(tempCartItems);
        }
      });
  };

  return { handleGetCart, isLoading, isSuccess, refetch };
};

export default useGetCart;
